import BoolField from "lib/components/ItemMetadataFields/fields/BoolField";
import DateTimeField from "lib/components/ItemMetadataFields/fields/DateTimeField";
import DropdownField from "lib/components/ItemMetadataFields/fields/DropdownField";
import MultipleField from "lib/components/ItemMetadataFields/fields/MultipleField";
import TextLikeField from "lib/components/ItemMetadataFields/fields/TextLikeField";
import { METADATA_FIELD_TYPE } from "lib/components/ItemMetadataFields/itemMetadata.constants";

const FIELD_COMPONENT_BY_TYPE = {
  [METADATA_FIELD_TYPE.Bool]: BoolField,
  [METADATA_FIELD_TYPE.DateTime]: DateTimeField,
  [METADATA_FIELD_TYPE.Dropdown]: DropdownField,
  [METADATA_FIELD_TYPE.Multiple]: MultipleField,
  [METADATA_FIELD_TYPE.Numeric]: TextLikeField,
  [METADATA_FIELD_TYPE.Text]: TextLikeField,
};

const getMetadataFieldComponent = (fieldType) =>
  FIELD_COMPONENT_BY_TYPE[fieldType];

export { FIELD_COMPONENT_BY_TYPE, getMetadataFieldComponent };
